import React from 'react';

const PaymentButton = ({ enabled = false, togglePaymentAmountChoice, id = 'btnPayNow' }) => {

    return (
        <button className={`inline-button ${!enabled && 'disabled'}`}
            id={id}
            onClick={() => {
                if (window?.mixpanel?.track) {
                    window.mixpanel.track("Pay Now Button Clicked");
                }
                togglePaymentAmountChoice();
            }}
            disabled={!enabled}>
            Pay now
        </button>
    )
}

export default PaymentButton